export default __webpack_public_path__ + "static/media/SuccessIcon.71bc2dc4.svg";